import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import configurationAPI from '../../apis/configuration/configurationAPI';

function CustomCard({
    setFeedbackCategoryDropdownsData,
    auditArea: {
        name: itemName = '',
        FeedbackCategoryDropdowns: items = [],
    },
    auditAreaId: itemId,
    invalidateFeedbackdropdowns,
    setInvalidateFeedbackdropdowns,
}) {
    const [finalUpdatedItems, setFinalUpdatedItems] = useState({ deleted: [], added: [] });
    const [itemsList, setItemsList] = useState([]);
    const [newItems, setNewItems] = useState([]);
    const [itemsForDuplicationCheck, setItemsForDuplicationCheck] = useState([]);

    useEffect(() => {
        setItemsList(items);
        setItemsForDuplicationCheck(items);
        // eslint-disable-next-line
    }, [items]);

    useEffect(() => {
        resetItemState();
        // eslint-disable-next-line
    }, [invalidateFeedbackdropdowns]);

    const handleAddItemInput = () => {
        setNewItems([...newItems, { id: uuidv4(), name: '' }]);
    };

    const handleItemsForCategory = async ({ updatedNewItems = newItems, updatedItemsList = itemsList, finalUpdated = finalUpdatedItems, deletedItem }) => {
        try {
            const editedItems = [];
            const addedItems = updatedNewItems.filter(i => i.name.trim() !== '').map((item) => item.name);

            updatedItemsList?.forEach((item) => {
                itemsForDuplicationCheck?.forEach((duplicateItem) => {
                    if (item?.id === duplicateItem?.id && item?.name !== duplicateItem?.name) {
                        editedItems.push(item);
                    }
                });
            });

            if (!addedItems?.length && !finalUpdated?.deleted?.length && !editedItems?.length) {
                setFeedbackCategoryDropdownsData((prev) => ({
                    ...prev,
                    [itemId]: {}
                }))
                return;
            };

            const reqBody = {};
            if (finalUpdated?.deleted?.length) {
                Swal.fire({
                    text: `Do you want to delete selected ${itemName}?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: 'btn btn-sm btn-primary',
                        cancelButton: 'btn btn-sm btn-secondary',
                    },
                }).then(async (result) => {
                    if (result?.value === true) {
                        reqBody.deleted = finalUpdated?.deleted;
                        if (editedItems?.length) {
                            reqBody.edited = editedItems;
                        }
                        if (addedItems?.length) {
                            reqBody.added = addedItems;
                        }
                        setFeedbackCategoryDropdownsData((prev) => ({
                            ...prev,
                            [itemId]: reqBody
                        }));

                        const feedbackCategoryDropdowns = { [itemId]: { deleted: reqBody.deleted } };

                        try {
                            const res = await configurationAPI.updateFeedbackCategoryDropdowns(feedbackCategoryDropdowns);
                            if (res.success) {
                                setFinalUpdatedItems(({ added: addedItems, deleted: [] }));
                                setInvalidateFeedbackdropdowns(prev => !prev);
                                window.toastr.success(res.message);
                            }
                        } catch (error) {
                            window.toastr.error(error.message)
                        }
                    } else {
                        setFinalUpdatedItems(prev => ({
                            deleted: [],
                            added: prev.added
                        }));
                        setItemsList(itemsForDuplicationCheck);
                    }
                });
            } else {
                if (editedItems?.length) {
                    reqBody.edited = editedItems;
                }
                if (addedItems?.length) {
                    reqBody.added = addedItems;
                }
                setFeedbackCategoryDropdownsData((prev) => ({
                    ...prev,
                    [itemId]: reqBody
                }));
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleItemChange = (id, value, isNew) => {
        if (isNew) {
            const updatedNewItems = newItems.map(item =>
                item?.id === id ? { ...item, name: value } : item
            );

            setNewItems(prev =>
                prev.map(item =>
                    item?.id === id ? { ...item, name: value } : item
                )
            );

            handleItemsForCategory({ updatedNewItems });
        } else {
            const updatedItemsList = itemsList.map(item =>
                item?.id === id ? { ...item, name: value } : item
            )
            setItemsList(prev =>
                prev.map(item =>
                    item?.id === id ? { ...item, name: value } : item
                )
            );

            handleItemsForCategory({ updatedItemsList });
        }

    };

    const handleDeleteItem = ({ id, isNew, itemId }) => {
        if (isNew) {
            setNewItems(prev => prev.filter((elem) => elem?.id !== id));
            const updatedNewItems = newItems.filter((elem) => elem?.id !== id);
            handleItemsForCategory({ updatedNewItems });
        } else {
            setFinalUpdatedItems(prev => ({
                deleted: [...prev.deleted, itemId],
                added: prev.added
            }));
            const finalUpdated = { deleted: [...finalUpdatedItems.deleted, itemId], added: finalUpdatedItems.added };
            const deletedItem = itemsList.filter((elem) => elem?.id === id);
            setItemsList(prev => prev.filter((elem) => elem?.id !== id));
            const updatedItemsList = itemsList.filter((elem) => elem?.id !== id);

            handleItemsForCategory({ updatedItemsList, finalUpdated, deletedItem });
        }
    };

    const resetItemState = () => {
        setItemsList(items);
        setItemsForDuplicationCheck(items);
        setNewItems([]);
        setFinalUpdatedItems({ deleted: [], added: [] });
    };

    const handleDeleteFeedbackCategory = async () => {
        Swal.fire({
            text: "Do you want to delete this category?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-sm btn-primary',
                cancelButton: 'btn btn-sm btn-secondary'
            },
        }).then(async (result) => {
            if (result?.value === true) {
                try {
                    const response = await configurationAPI.deleteFeedbackCategory(itemId);
                    if (response?.success) {
                        window.toastr.success(response?.message);
                        setFeedbackCategoryDropdownsData((prev) => ({
                            ...prev,
                            [itemId]: {}
                        }));
                        setInvalidateFeedbackdropdowns(prev => !prev);
                    }
                } catch (error) {
                    window.toastr.error(error?.message);
                }
            }
        })
    }

    return (
        <div className="card card-flush mb-4">
            <div className="card-header minimize">
                <div className="card-title">
                    <h4>{itemName}</h4>
                </div>
                <div className="card-toolbar mt-0">
                    <i onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteFeedbackCategory();
                    }}
                        className="ms-4 fas fa-trash" />
                    <button className="btn btn-icon btn-sm btn-light-gray justify-content-center ">
                        <i className="fas fa-minus"></i>
                    </button>
                </div>
            </div>
            <div className="card-body pt-0">
                <div
                    className=""
                    data-kt-ecommerce-catalog-add-product="auto-options"
                >
                    <div id="kt_ecommerce_add_product_options">
                        <div className="form-group">
                            <div
                                data-repeater-list="kt_ecommerce_add_product_options"
                                className="d-flex flex-column gap-3"
                            >

                                <div className="mt-4">
                                    {itemsList.length === 0 && <p className="text-warning text-center">Please add atleast one item for this category!</p>}
                                    {(itemsList.length > 0 || newItems.length > 0) && (
                                        <>
                                            {itemsList.map((item) => (
                                                <div key={item.id} className="mt-1 form-group d-flex flex-wrap align-items-center gap-2">
                                                    <input
                                                        type="text"
                                                        className="form-control mw-100 w-75 mb-2"
                                                        value={item.name}
                                                        onChange={(e) => handleItemChange(item.id, e.target.value, false)}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-icon btn-light-danger"
                                                        onClick={(e) => handleDeleteItem({ id: item?.id, isNew: false, itemId: item.id })}
                                                    >
                                                        <span className="svg-icon svg-icon-1">
                                                            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <rect opacity="0.5" x="7.05" y="15.5356" width="12" height="2" rx="1" transform="rotate(-45 7.05 15.5356)" fill="currentColor" />
                                                                <rect x="8.46447" y="7.05029" width="12" height="2" rx="1" transform="rotate(45 8.46447 7.05029)" fill="currentColor" />
                                                            </svg>
                                                        </span>
                                                    </button>
                                                </div>
                                            ))}
                                            {newItems.map((item) => (
                                                <div key={item.id} className="mt-1 form-group d-flex flex-wrap align-items-center gap-2">
                                                    <input
                                                        type="text"
                                                        className="form-control mw-100 w-75 mb-2"
                                                        value={item.name}
                                                        onChange={(e) => handleItemChange(item.id, e.target.value, true)}
                                                        placeholder="Enter item"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-icon btn-light-danger"
                                                        onClick={() => handleDeleteItem({ id: item?.id, isNew: true })}
                                                    >
                                                        <span className="svg-icon svg-icon-1">
                                                            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <rect opacity="0.5" x="7.05" y="15.5356" width="12" height="2" rx="1" transform="rotate(-45 7.05 15.5356)" fill="currentColor" />
                                                                <rect x="8.46447" y="7.05029" width="12" height="2" rx="1" transform="rotate(45 8.46447 7.05029)" fill="currentColor" />
                                                            </svg>
                                                        </span>
                                                    </button>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                </div>
                                <div className="mt-2 float-end">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-light me-4"
                                        onClick={handleAddItemInput}
                                    >
                                        <span className="svg-icon svg-icon-2">
                                            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor" />
                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" />
                                            </svg>
                                        </span>
                                        Add another
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomCard